import { render } from "./DashboardVerticalBarChart.vue?vue&type=template&id=fd6132b0"
import script from "./DashboardVerticalBarChart.vue?vue&type=script&lang=js"
export * from "./DashboardVerticalBarChart.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__